import callAPI from "../callApi";
import path from "../variables";

const Reservation = {
	getAll: (filter?: string) =>
		callAPI("GET", `${path.base}/reservations${filter || ""}`, "", "getting all reservations"),
	create: (data: any) =>
		callAPI("POST", `${path.base}/reservations`, data, "creating reservation"),
	confirm: (id: number) =>
		callAPI("POST", `${path.base}/reservations/confirm/${id}`, "", "confirming reservation"),
	cancel: (id: number) =>
		callAPI("POST", `${path.base}/reservations/cancel/${id}`, "", "cancelling reservation"),
};

export default Reservation;
